const options = {
  siteTitle: 'Paymish',
  showLeftSidebarInner: true,
  showLeftSidebarInnerSearch: false,
  showRightSideBar: false,
  defaultUserLogo: '',
  showMessageNotification: false,
  showCustomNotification: false,
  showTaskNotification: false,
  showLoggedInUserInfoInSideMenu: false,
  copyRightText: '', // Footer Text
  appVersion: '1.0', // Footer App Version
  defaultUserIcon: 'src/assets/img/user.png',
  defaultSiteLogo: 'assets/img/bottom_logo.svg',
  miniSiteLogo: 'assets/img/paymish_mini.svg'
};
export default options;
